import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

interface NavigationButtonsProps {
  currentStep: number;
  onNext: () => void;
  onBack?: () => void;
  isLoading?: boolean;
}

export const NavigationButtons = ({
  currentStep,
  onNext,
  onBack,
  isLoading = false,
}: NavigationButtonsProps) => {
  return (
    <div className="flex flex-col-reverse sm:flex-row sm:items-center sm:justify-between gap-3 mt-10 pt-2 border-t border-border/60">
      <div className="flex justify-center sm:justify-start">
        {onBack ? (
          <Button
            type="button"
            variant="ghost"
            onClick={onBack}
            disabled={isLoading}
            className="text-muted-foreground"
          >
            <ChevronLeft className="h-4 w-4 mr-1" />
            Voltar
          </Button>
        ) : (
          <span className="hidden sm:block w-[88px]" aria-hidden />
        )}
      </div>
      <Button
        type="button"
        onClick={onNext}
        loading={isLoading}
        keyLoader="navigation"
        className="w-full sm:w-auto min-w-[140px]"
        size="lg"
      >
        {currentStep === 2 ? "Finalizar cadastro" : "Continuar"}
        {!isLoading && <ChevronRight className="h-4 w-4 ml-1" />}
      </Button>
    </div>
  );
};
